import api from './axiosApi';

export const getPostcodeLocation = async (postcode) => {
  const { data } = await api.get(`/postcode/${postcode}/location`);
  return data;
};
